if (!customElements.get('wlsn-pagination')) {
  class WLSNPagination extends HTMLElement {
    constructor() {
      super();
      this.onClick = this._onClick.bind(this);
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    /**
     * Disconnected callback lifecycle method
     * @returns {void}
     */
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    /**
     * Handle click event on pagination links
     * @param {Event} event - The click event
     * @returns {void}
     */
    _onClick(event) {
      if (!this.hasAttribute('ajax')) return;

      const link = event.target.closest('a[data-page]');
      if (!link) return;

      event.preventDefault();

      const url = new URL(window.location.href);
      url.searchParams.set('page', link.dataset.page);

      window.WLSNHelpers.triggerEvent(this, 'wlsn:pagination:page-changed', { url: url.toString() });
    }
  }

  customElements.define('wlsn-pagination', WLSNPagination);
}
